export default __webpack_public_path__ + "static/me-e9a242fe38a5e39151b95e816e278179.png";